import React, { useState } from 'react'
import DropDownBox from "./DropDownBox"
import "./FaqSection.css"
import CalendlyFormModal from '../CalendlyFormEmbed/CalendlyFormEmbed'

const eligFaq = [
  {
    "title": "Can Canadian citizens access your services?",
    "content": "Yes. Canadian citizens—whether self-employed or employed through a corporation—can access our services directly. Many of our members choose to pay through a corporate structure, which may provide tax efficiency depending on your accountant’s recommendations."
  },
  {
    "title": "Can foreign nationals access your program?",
    "content": "Absolutely. We welcome foreign nationals, expats, and internationally based professionals. While OHIP coverage may not apply to all services, we can tailor programs for individuals who wish to receive comprehensive preventive care while living or working in Canada."
  },
  {
    "title": "Do you accept families into the program?",
    "content": "Yes, we do. While our program is designed for individual optimization, many of our members enroll their spouses or family members to ensure consistency in care and convenience. We offer flexible arrangements for dual or family memberships."
  },
  {
    "title": "Do you work with elderly patients?",
    "content": "Yes. Many of our members are in their 60s, 70s, or beyond. Preventive care becomes increasingly valuable with age, and our team is experienced in addressing age-specific concerns with dignity, thoroughness, and a personalized approach."
  },
  {
    "title": "Are there any tax benefits to joining?",
    "content": "Potentially, yes. If you're an incorporated business owner or executive, your accountant may be able to classify our services as a business expense. While we don’t provide financial advice, many members explore this option with their tax advisors."
  }
]


const serviceFaq= [
  {
    "title": "When is the right age to start a program like this?",
    "content": "We typically see members join in their 40s and 50s—but truly, the best time is when you’re ready to take your health seriously. Whether you're optimizing performance or getting ahead of potential risks, the earlier you start, the more impact we can make."
  },
  {
    "title": "How long is the membership, and is it renewable?",
    "content": "Memberships run annually and are renewable each year. Many members choose to continue long-term because of the consistency, access, and peace of mind the program provides."
  },
  {
    "title": "What’s the difference between this and a traditional clinic?",
    "content": "Traditional clinics often focus on reactive care. We take a proactive, concierge approach—coordinating specialists, using advanced diagnostics, and spending far more time with each patient. It’s like having a medical advisory board for your life."
  },
  {
    "title": "Is this covered by OHIP or private insurance?",
    "content": "Most of our services fall outside the scope of OHIP. However, certain diagnostics or consultations may be partially reimbursable through private insurance or Health Spending Accounts (HSA). We can provide documentation to help you explore this."
  },
  {
    "title": "What makes your clinic different from other executive health programs?",
    "content": "Beyond our multi-disciplinary team and clinical depth, it's our commitment to truly knowing our members. We don’t just run tests—we build relationships, track you closely, and evolve your plan over time. That level of continuity is rare."
  }
]


const expectFaqs = [
  {
    "title": "Who manages my health?",
    "content": "Your care is managed by a tightly integrated, multidisciplinary team that includes physicians, naturopathic doctors, specialists, and allied health providers. We meet regularly to discuss your case and ensure all aspects of your health are aligned."
  },
  {
    "title": "What happens during my monthly calls?",
    "content": "Each call is a structured follow-up to review any acute issues, update your ongoing problem list, assess your progress, and identify new areas for optimization. It’s a dedicated check-in to make sure you’re always moving forward."
  },
  {
    "title": "What kind of tests or screenings do you do?",
    "content": "We tailor screenings based on age, risk factors, and health goals. This may include blood panels, cardiovascular screening, hormonal analysis, cancer risk assessments, and other diagnostics that go beyond standard care."
  },
  {
    "title": "Can you refer me to specialists?",
    "content": "Yes. We have a trusted network of specialists and will refer you as needed—often with expedited access. We remain involved throughout the process, so your care stays coordinated and nothing gets lost in translation."
  },
  {
    "title": "How quickly can I access care if something urgent comes up?",
    "content": "Members have 24/7 access to our team. For non-emergency urgent concerns, we can typically coordinate care the same or next day. Your health shouldn’t have a waitlist—and with us, it doesn’t."
  }
]

const pelvicFaqData  = [
  {
        title:"WHO IS THE RIGHT CANDIDATE FOR TREATMENT?",
        content:"Bladder leakage is more common in women which makes them the right candidates for treatment. Also, women who have the need to strengthen their pelvic floor and improve their sexual function."
    },
    {
        title:"HOW LONG DOES THE TREATMENT LAST?",
        content:"Each treatment lasts 28 minutes in duration."
    },
    {
        title:"DO I NEED TO REMOVE MY CLOTHES DURING MY SESSION?",
        content:"There is no need to remove your clothing. You simply sit on the comfortable chair and have your treatment session."
    },
    {
        title:"IS THERE ANY PHYSICAL CONTACT REQUIRED?",
        content:"No.  There is no physical contact required with anyone during your treatment. All you need to do is sit on the treatment chair and feel the electromagnetic energy to your pelvic floor muscles. During that time you can read your favorite book or watch your favorite tel"
    },
    {
        title:"IS THE TREATMENT PAINFUL?",
        content:"The treatment does not cause any pain. You will feel tingling and contractions of your pelvic floor muscles and after you are done with the treatment, you can go back to your normal daily activities."
    },
    {
        title:"ARE THERE ANY SIDE EFFECTS?",
        content:"There are no negative side effects associated with our treatment."
    },
    {
        title:" HOW FAST WILL I EXPERIENCE RESULTS?",
        content:"You will begin to notice an improvement after the first session, and with each subsequent appointment you will continue to improve."
    },
    {
        title:" WHO IS NOT A GOOD CANDIDATE FOR TREATMENT?",
        content:"It is not recommended for pregnant women, women who have had a metal hip replacement, have a pacemaker, or have a copper IUD in place. It is recommended for pregnant women to get the treatment after the pregnancy ends."
    },
    {
        title:" HOW SOON AFTER PREGNANCY SHOULD I WAIT BEFORE TREATMENT?",
        content:"Once your doctor tells you that you are ready to start exercising, you can schedule your appointment with us."
    },
    {
        title:"IS THE TREATMENT SAFE?",
        content:"The treatment is completely safe and approved by both the FDA and Health Canada."
    },
    {
        title:" WHAT SHOULD I WEAR DURING MY SESSIONS?",
        content:"Please wear comfortable- fitting clothes so you can feel relaxed during the treatment."
    },
    // {
    //     title:" CAN MEN RECEIVE TREATMENT?",
    //     content:"Yes. Men can (and do) benefit from this therapy. Men also struggle with bladder leakage issues and the treatment will benefit them as well."
    // },
    {
      setHtml:true,
        title:"WHAT MAKES THIS TREATMENT DIFFERENT FROM PHYSIOTHERAPY OR KEGEL TRAINING?",
        content:`<p>
  Pelvic physiotherapy improves muscle control through manual activation and 
  guided exercises. However, this treatment provides:
</p>

<ul>
  <li>11,000–15,000 contractions in 28 minutes</li>
  <li>activation deeper than manual exercise can reach</li>
  <li>uniform, rhythmic muscle firing</li>
  <li>engagement of the entire pelvic floor hammock (not just the front muscles)</li>
</ul>

<p>
  Most providers use it as an accelerator — combining pelvic therapy + pelvic 
  chair leads to significantly faster improvements than either alone.
</p>
`
    },
    {
        title:"IS THIS COVERED BY OHIP?",
        content:"No, it is not."
    },
    {
        title:"IS THIS COVERED BY EXTENDED HEALTH BENEFITS?",
        content:"Our team will provide you with the necessary information to support your insurance claim. Note that treatment is not typically covered under standard health benefits."
    },
    {
        title:"CAN I CLAIM THIS ON MY TAX RETURN?",
        content:"Yes, our team will advise you on how to claim the treatment costs as a medical expense for your income tax return."
    },
    {
        title:"CAN THIS TREATMENT HELP WITH ENDOMETRIOSIS?",
        content:"Women with endometriosis can get improvements with their condition, with pain decreasing over time."
    },
    // {
    //     title:"CAN'T FIND THE ANSWER TO YOUR QUESTION?",
    //     content:"Yes, our team will advise you on how to claim the treatment costs as a medical expense for your income tax return."
    // },
    {
        title:"WHAT HAPPENS IF I SKIP A SESSION? WILL MY RESULTS BE AFFECTED?",
        content:"Consistency improves results, but one missed session won’t erase progress. However, long gaps (1–2 weeks) can slow neuromuscular adaptation. If a session is missed, the provider will adjust intensity during the next visit."
    },
    {
        title:"WHAT IS IT SUPPOSED TO FEEL LIKE?",
        content:"Our chair feels like comfortable electric impulses entering into the pelvic floor. Think of a TENS machine going for over 11 thousand pulses in a spot that is built to handle it."
    },
    {
        title:"WHAT’S THE REASON FOR THE BREAK IN BETWEEN PROTOCOLS?",
        content:"The reason for the break in between protocols 1 and 2 is to rest the pelvic floor and help rejuvenate the area, similar to how you'd let any muscle rest after a gym session. Often, there’s continuous improvement during the rest period!"
    },
    {
        title:"WHEN CAN/SHOULD I COME BACK FOR MAINTENANCE?",
        content:"We advise maintenance treatments along with yoga or pilates classes that focus on the pelvic floor (which most do). We also recommend that people do Kegel’s outside of the clinic. The work you put into your body to help improve your pelvic floor function (body mechanics, diet, core exercises) is extremely important."
    },
    // {
    //     title:"WHEN CAN/SHOULD I COME BACK FOR MAINTENANCE?",
    //     content:"We advise maintenance treatments along with yoga or pilates classes that focus on the pelvic floor (which most do). We also recommend that people do Kegel’s outside of the clinic. The work you put into your body to help improve your pelvic floor function (body mechanics, diet, core exercises) is extremely important. The better you take care of pelvic health outside of Venus, the better off you will be."
    // },
    {
        title:"WHY SHOULDN’T I DRINK COFFEE?",
        content:"We advise against coffee, alongside decaf, because of the caffeine. Caffeine is a powerful diuretic and can be very irritating to the bladder when you're incontinent. You may notice this with a bladder diary, which will help track what you were doing, eating, emotions, accidents, time of day, and nighttime bathroom trips. Alongside caffeine, it is in your best interest to identify other triggers that cause bladder accidents using the diary."
    },
]

const pelvicFloorMenData  = [
  {
    "title": "WHY DO I SUDDENLY HAVE BLADDER LEAKS?",
    "content": "Leaks often happen when pelvic muscles weaken due to aging, surgery, or sitting for long periods. This treatment strengthens those muscles to help regain control."
  },
  {
    "title": "WHO IS AN IDEAL CANDIDATE FOR THIS TREATMENT?",
    "content": "Men experiencing urinary incontinence, weak pelvic muscles, or decreased sexual performance due to aging, surgery, or sedentary lifestyle are ideal candidates. A consultation can determine if it’s right for you."
  },
  {
    "title": "HOW DOES THE TREATMENT WORK?",
    "content": "The device uses electromagnetic stimulation to induce over 11,000 deep muscle contractions per session. These contractions strengthen muscles that are difficult to target through exercise alone."
  },
  {
    "title": "IS THE PROCEDURE PAINFUL?",
    "content": "No. The treatment is completely non-invasive. Most clients feel only gentle muscle contractions while remaining fully clothed and comfortable throughout the 28-minute session."
  },
  {
    "title": "HOW LONG DOES EACH SESSION LAST?",
    "content": "Each session is approximately 28 minutes, making it easy to fit into a busy schedule without disrupting daily activities."
  },
  {
    "title": "HOW MANY SESSIONS ARE NEEDED TO SEE RESULTS?",
    "content": "Many clients notice improvements after just a few sessions. The exact number varies depending on individual goals and the degree of pelvic weakness."
  },
  {
    "title": "IS THERE ANY DOWNTIME AFTER TREATMENT?",
    "content": "No downtime is required. You can resume normal activities immediately after the session without any discomfort or restrictions."
  },
  {
    "title": "CAN THIS TREATMENT IMPROVE SEXUAL PERFORMANCE?",
    "content": "Yes. By strengthening the pelvic floor muscles, blood flow and muscle control improve, which can positively impact sexual performance and confidence."
  },
  {
    "title": "ARE THERE ANY SIDE EFFECTS?",
    "content": "The treatment is generally safe and well-tolerated. Some individuals may experience mild temporary muscle soreness, similar to after a workout, but it usually resolves quickly."
  },
  {
    "title": "DO I NEED TO PREPARE BEFORE A SESSION?",
    "content": "No special preparation is required. You simply sit comfortably and allow the device to do the work while fully clothed."
  },
  {
    "title": "CAN THIS THERAPY HELP AFTER PROSTATE SURGERY?",
    "content": "Yes. Men who have undergone prostate surgery often experience weakened pelvic muscles. This therapy helps restore strength, control, and function over time."
  },
  {
    "title": "HOW DOES IT HELP WITH BLADDER LEAKAGE?",
    "content": "The treatment strengthens the pelvic muscles responsible for bladder control. This reduces accidental leaks and improves confidence in daily activities."
  },
  {
    "title": "CAN OLDER MEN BENEFIT FROM THIS TREATMENT?",
    "content": "Absolutely. Age-related pelvic muscle weakening is common. The therapy is effective for men of all adult ages, helping maintain independence and quality of life."
  },
  {
    "title": "WILL EXERCISE ALONE WORK AS WELL?",
    "content": "Targeted exercises help, but many pelvic muscles are difficult to reach. This treatment activates deeper muscles that standard exercises often cannot, delivering faster and more consistent results."
  },
  {
    "title": "HOW LONG DO RESULTS LAST?",
    "content": "Results improve over time with consistent treatment. Many clients experience lasting benefits for months, especially when combined with recommended exercises and lifestyle adjustments."
  },
  {
    "title": "IS THIS TREATMENT FDA-APPROVED OR CLINICALLY PROVEN?",
    "content": "Yes. The therapy is clinically validated and delivered in a safe, controlled medical setting by trained professionals."
  },
  {
    "title": "CAN THIS TREATMENT PREVENT FUTURE ISSUES?",
    "content": "Strengthening the pelvic muscles reduces the risk of further weakening and can prevent future bladder or core-related problems, supporting long-term health."
  },
  {
    "title": "HOW OFTEN SHOULD I HAVE SESSIONS?",
    "content": "Frequency depends on individual assessment, but most clients start with multiple sessions per week initially."
  },
  {
    "title": "DOES IT HELP WITH CORE STABILITY?",
    "content": "Yes. Pelvic floor muscles are a key part of your core. Strengthening them improves overall stability, posture, and functional movement."
  },
  {
    "title": "IS IT SAFE FOR MEN WITH MEDICAL CONDITIONS?",
    "content": "The treatment is generally safe, but your medical history will be reviewed during consultation to ensure safety. Any concerns can be addressed by the clinical team before starting."
  },
  {
    "title": "HOW DO I START THE TREATMENT?",
    "content": "Book a personal consultation to discuss your symptoms, goals, and treatment plan. Our team will guide you through the process, tailoring sessions for optimal results and confidence restoration."
  },
  {
    "title": "CAN I CLAIM THIS TREATMENT ON MY TAX RETURN?",
    "content": "Yes. Our team will guide you on how to claim the treatment costs as a medical expense for your income tax return. We provide the necessary documentation and advice to make the process easier."
  }
]

const edSureFaqData  = [
  {
    title: "What is Erectile Dysfunction Shockwave Treatment?",
    content: `Shockwave Therapy is a Low Intensity Shockwave Therapy, which is a safe, effective, and non-invasive treatment for erectile dysfunction by increasing penile blood flow to improve sexual performance. Shockwave Therapy uses a Swiss-made medical device cleared by the Food and Drug Administration (FDA) for use on the human body as a massage device for soft tissue repair and improved blood flow, among other uses. Use of this equipment according to our established best practice protocol along with perfect calibration is what makes Shockwave Therapy a powerful and effective treatment for Erectile Dysfunction.`
  },
  {
    title: "What about Shockwave Therapy is proven to work?",
    content: `Shockwave Therapy is proven to show long lasting results including:
- Enhanced Erections
- Increased Penile Sensation
- Improved Sexual Performance`
  },
  {
    title: "Who are good candidates for Erectile Dysfunction Shockwave Treatment?",
    content: `Men of all ages suffering with erectile dysfunction – Shockwave Therapy is a safe, effective, drug-free, surgery-free alternative to Viagra®, Cialis®, and other oral erectile dysfunction medications.

Men of all ages suffering with Peyronie’s Disease – Shockwave Therapy’s Low Intensity Shockwave treatments have been shown to be a drug-free, surgery-free way to reduce the curvature of the penis and break down the scar tissue usually occurring with Peyronie’s Disease.

Men of all ages seeking male enhancement – Men do not have to be suffering from erectile dysfunction or any other medical condition to benefit from Shockwave Therapy. Healthy males who have had Low Intensity Shockwave treatments report harder, more sustained erections after one treatment.`
  },
  {
    title: "What age is appropriate for Shockwave Therapy to be effective?",
    content: `Shockwave Therapy could actually roll back the clock for most men, possibly allowing men of ages up to 80, even 90 to perform as they did in their more virile years. The treatment is not contraindicated for men of any age. Schedule an appointment with our clinic today to learn if this treatment can help.`
  },
  {
    title: "Why is Shockwave Therapy a better alternative to drugs?",
    content: `Viagra®, Cialis®, and Levitra can really only help half of all men dealing with erectile dysfunction due to contraindications and side effects of the drugs. With Shockwave Therapy there are no expensive prescriptions, or pills to remember to take. There are no harmful side effects with Shockwave Therapy as there are with oral erectile dysfunction and male performance drugs. Shockwave Therapy can also be used to treat Peyronie’s Disease, which Viagra® and other oral ED drugs cannot.`
  },
  {
    title: "Why should I choose Men's Health instead of other Low Intensity Shockwave clinic options?",
    content: `We are the exclusive provider in Ontario with the specific equipment and training to calibrate and administer Shockwave Therapy. While there are other providers who source and use Chinese-manufactured and other devices, precision is key for this treatment option. To have the desired effect on erectile tissue the acoustic Shockwave must be focused to one millimeter. If the Shockwave is not perfectly calibrated the treatment won’t be effective or long-lasting.`
  },
  {
    title: "How does Erectile Dysfunction Shockwave Treatment work?",
    content: `Gentle, low-intensity Shockwave are released via a rod that is moved over the penis shaft and base. The Shockwave promote neovascularization, or the formation of new blood vessels, as well as opening of existing blood vessels.`
  },
  {
    title: "Are there any side effects of the treatment?",
    content: `Low Intensity Shockwave treatments have no known side effects.`
  },
  {
    title: "How soon after treatment will I see results?",
    content: `Benefits will vary based on individual’s health history and diagnosis. In our experience, patients can see improvements after as few as 2 treatments.`
  },
  {
    title: "How many treatments of Shockwave Therapy will I need?",
    content: `When you meet with one of our clinicians, we’ll discuss your medical goals to develop a treatment plan for optimal results. It will typically take 6-10 treatments of Shockwave Therapy.`
  },
  {
    title: "How long can I expect to benefit from Shockwave Therapy?",
    content: `The research and trials associated with Shockwave Therapy have shown no time limitations on the treatment benefits.`
  },
  {
    title: "How long has the Shockwave Therapy been used to treat ED?",
    content: `While new to Canada, the Shockwave Therapy treatment approach has been successfully used in Europe for the past 15 years.`
  },
  {
    title: "Is there clinical research on Low Intensity Shockwave treatments available?",
    content: `Independent published research papers have proven its safety and efficacy with 86% of men saying they would recommend it to a friend. There have been multiple public studies confirming the effectiveness of Low Intensity Shockwave Therapy as a treatment for erectile dysfunction.`
  }
];


function FaqSection({  
    heading="",
    para="",
    subHeading="",
    showImg=false,
    faqData=[],
    headingBlue="",
    showBtn=true,
    pelvicFaq=false,
    pelvicFloorMen=false,
    edSureFaq=false,
    btnText="Explore membership",
    btnCalnedly=false,
    calendlyType=0
}) 
{
    const [faqsList,setFaqList] = useState(eligFaq)
    const [faqsListId,setFaqListId] = useState(1)
    const [selected, setSelected] = useState(1);
    const [openCalendly, setOpenCalendly] = useState(false);
  const [fadeClass, setFadeClass] = useState("fade-in");

  const handleSelect = (type) => {
    if (type !== selected) {
      setFadeClass("fade-out");
      setTimeout(() => {
        setSelected(type)
        setFaqListId(type)
        switch (type) {
            case 1:
                setFaqList(eligFaq)
                break;
        
            case 2:
                setFaqList(serviceFaq)
                break;
        
            case 3:
                setFaqList(expectFaqs)
                break;
        
            default:
                break;
        }
        setFadeClass("fade-in");
      }, 300); 
    }
  };

  return (
    <div className='faq-container standard-padding-space mt-3 mt-lg-5'>
       {
                  openCalendly &&
                  <CalendlyFormModal intialOpenState={openCalendly} setOpenState={setOpenCalendly} calendlyType={calendlyType}/>
              }
        <div className='container my-0 my-md-4'>
            <div className='row align-items-center'>
                <div className='col-lg-6'>
                    <div className='text-content '>
                        <h3 className='body-heading'>{heading} {headingBlue && <span className='color-blue'>{headingBlue}</span>}</h3>
                        <h6 className='sub-heading my-4' >{subHeading}</h6>
                        <p className='body-paragraph'>{para}</p>
                    </div>
                </div>
                <div className='col-lg-6 text-lg-end text-center'>
                  {
                    showBtn &&
                    <button className='genral-btn '
                      onClick={()=>{
                        if(btnCalnedly)
                        {
                          setOpenCalendly(true)
                        }
                      }}
                    >{btnText}</button>
                  }

                </div>

                {
                  edSureFaq?
                    <>
                  <div className='col-lg-12 pt-5'>

                      <div className={`dropdown-container row ${fadeClass} faq-list `}>
                          {
                              edSureFaqData.map((ele)=>{
                                  return(
                                      <div className='col-lg-6 py-2'>
                                          <DropDownBox 
                                          title={ele.title} 
                                          content={ele.content} />
                                      </div>
                                  )
                              })
                          }
                      </div>
                  </div>
                    </>

                  :
                  <>
                  {
                  pelvicFaq?
                  <>
                  {
                    pelvicFloorMen?
                      <div className='col-lg-12 pt-5'>

                    <div className={`dropdown-container row ${fadeClass} faq-list `}>
                        {
                            pelvicFloorMenData.map((ele)=>{
                                return(
                                    <div className='col-lg-6 py-2'>
                                        <DropDownBox 
                                        title={ele.title} 
                                        content={ele.content} 
                                        setHtml={ele?.setHtml || false}
                                        />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                    :
                      <div className='col-lg-12 pt-5'>

                    <div className={`dropdown-container row ${fadeClass} faq-list `}>
                        {
                            pelvicFaqData.map((ele)=>{
                                return(
                                    <div className='col-lg-6 py-2'>
                                        <DropDownBox 
                                        title={ele.title} 
                                        content={ele.content} 
                                        setHtml={ele?.setHtml || false}
                                        />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>


                  }
              
                  </>
                  :
                  <>
                <div className='col-lg-6 text-start'>
                        <div className='mt-4'>
                            <h5 className={`sub-heading mb-4 ${faqsListId==1 ? "color-blue":"color-dark"} `} style={{fontWeight:"800",cursor:"pointer"}} onClick={()=>{handleSelect(1)}}>Elegibility</h5>
                            <h5 className={`sub-heading mb-4 ${faqsListId==2 ? "color-blue":"color-dark"} `} style={{fontWeight:"800",cursor:"pointer"}} onClick={()=>{handleSelect(2)}}>General</h5>
                            <h5 className={`sub-heading mb-4 ${faqsListId==3 ? "color-blue":"color-dark"} `} style={{fontWeight:"800",cursor:"pointer"}} onClick={()=>{handleSelect(3)}}>Service</h5>
                        </div>

                </div>
                
                <div className='col-lg-6 pt-5'>

                    <div className={`dropdown-container row ${fadeClass} faq-list `}>
                        {
                            faqsList.map((ele)=>{
                                return(
                                    <div className='col-12'>
                                        <DropDownBox 
                                        title={ele.title} 
                                        content={ele.content} />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                  </>
                  }
                  </>
                }

               
            </div>
        
    </div>
    
</div>
  )
}

export default FaqSection